import React from "react";
import { Link } from "react-router-dom";

export const returnNavigation = (authData, location) => {
  return navigationItems
    .map((item) => {
      let checkNavBlock = [];
      const pathNames = item.dropDownOptions.map((e) => e.to);
      const isActive = pathNames.includes(location)
        ? "header-link--active"
        : "";
      const options = item.dropDownOptions.map((el) => {
        const checkDDOptions = item.dropDownOptions;
        for (let k = 0; k < checkDDOptions.length; k++) {
          if (authData.includes(checkDDOptions[k].permission)) {
            checkNavBlock = [...checkNavBlock, checkDDOptions[k].permission];
          }
        }
        const opt = authData.includes(el.permission);
        const className =
          opt || el.permission === ""
            ? "header-link"
            : "header-link disabled-block d-none";
        return (
          <Link key={el.option} to={el.to} className={className}>
            {el.option}
          </Link>
        );
      });
      return (
        <div
          key={item.text}
          className={`header-link global-track ${isActive} ${
            checkNavBlock.length !== 0 ? "" : "disabled-block"
          }`}
        >
          {item.text}
          <span className="arrow-zone">
            <span className="header-arrow" />
          </span>
          <div className="global-dropdown">{options}</div>
        </div>
      );
    })
    .filter((item) => item.text !== "Clients");
};

export const returnMobileMenu = () => {
  return navigationItems.map((item) => {
    return (
      <div className="d-flex flex-column" key={item.text}>
        <Link to={item.to}>{item.text}</Link>
        {item.dropDownOptions.map((el, i) => {
          return (
            <Link key={item.to} to={el.to} className="ml-5">
              {el.option}
            </Link>
          );
        })}
      </div>
    );
  });
};

const navigationItems = [
  {
    to: "/#",
    text: "Legis",
    dropDownOptions: [
      {
        to: "/legisnewrecordreview",
        option: "new record review",
        permission: "Legis: View NRR",
      },
      {
        to: "/legistrackinternal",
        option: "Legis Track",
        permission: "Legis: Internal View",
      },
      {
        to: "/statusreview",
        option: "Status Review",
        permission: "Status Processing: View",
      },
      {
        to: "/sponsorreview",
        option: "Sponsor Review",
        permission: "Sponsor Review: View",
      },
      {
        to: "/rawbilldata",
        option: "Raw Bill Data Entry",
        permission: "RawData: Edit",
      },
      {
        to: "/historyhelptext",
        option: "History Action Help Text",
        permission: "HistoryActionHelp: View",
      },
      {
        to: "/legislatordata",
        option: "Legislator Management",
        permission: "Legislator: Edit",
      },
    ],
  },
  {
    to: "/#",
    text: "Regs",
    dropDownOptions: [
      {
        to: "/registerreview",
        option: "Register Review",
        permission: "Register Review: View",
      },
      {
        to: "/regsurls",
        option: "Agency Review",
        permission: "Regs: View URLs",
      },
      {
        to: "/regsnewrecordreview",
        option: "new record review",
        permission: "Regs: View NRR",
      },
      {
        to: "/regstrackinternal",
        option: "regs track",
        permission: "Regs: Internal View",
      },
      {
        to: "/agencyedit",
        option: "Agency Edit",
        permission: "Regs: View Agencies",
      },
    ],
  },
  {
    to: "/#",
    text: "Local",
    dropDownOptions: [
      {
        to: "/localreview",
        option: "local review",
        permission: "Local Review: View",
      },
      {
        to: "/localtrackinternal",
        option: "local track",
        permission: "Local: Internal View",
      },
      {
        to: "/clientlocalities",
        option: "client localities",
        permission: "Local Review: View Client Localities",
      },
    ],
  },
  {
    to: "/#",
    text: "Global",
    dropDownOptions: [
      {
        to: "/#",
        option: "option 1",
        permission: "global permission",
      },
    ],
  },
  {
    to: "/#",
    text: "Reports",
    dropDownOptions: [
      {
        to: "/#",
        option: "option 1",
        permission: "reports permission",
      },
    ],
  },
  {
    to: "/clients",
    text: "Clients",
    dropDownOptions: [
      {
        to: "/clientmanagement",
        option: "Client Management",
        permission: "Client Management permission",
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Header/helpers.js